import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { Divider } from 'antd'
import { Button } from 'antd'

import { StyledTable } from 'components/TableStyles/TableStyles'

import { StyledTabs } from 'components/TabsPaneStyles'

export const FilterSummaryBar = styled.div`
  background: ${COLORS.GREY_T_97};
  border-radius: 4px;
  padding: 14px 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


export const FilterSummary = styled.div`
  display: flex;
  align-items: center;
  background: ${COLORS.GREY_T_97};
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 16px;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
`

export const ClearButton = styled(Button)`
  margin-left: 16px;
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
`


export const StyledDivider = styled(Divider)`
  margin: 16px 0;
  border-top: 2px solid #e8e8e8;
`

export const PaddedDiv = styled(Flex)`
  padding-left: 20px;
  padding-right: 20px;
  gap: 10px;
`
export const PaddedDivHome = styled(Flex)`
  padding-right: 20px;
  gap: 10px;
`

export const SectionWrapper = styled(Flex)`
  width: 100%;
  min-height: 79vh;
  height: 100%;
  overflow-y: auto;
`

export const TopHeader = styled(Flex)`
  width: 100%;
  font-size: ${FONT.F_XL};
  font-weight: 600;
  color: ${COLORS.BLACK};
`

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.padding || '10px 24px'};
  box-sizing: border-box;
  min-height: 70px; // Forces minimum height
`


export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`

export const CardRow = styled(Flex)`
 
  gap: 10px;
`
export const CardRowSpaceBetween = styled(Flex)`
  padding: 0 25px 25px 0px;
  gap: 20px;
`


export const TableHeader = styled(Flex)`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 42px;
  background: ${COLORS.WHITE};
  border-bottom: 1px solid ${COLORS.GREY_T_95};
  align-items: center;
  justify-content: space-between;
`
export const SearchSection = styled(Flex)`
  display: flex;
  flex: 2.2;
  min-width: 200px;
  height: 48px; // Increased height
  align-items: center;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 2px;
  margin: 0;
  padding: 0;
  margin-bottom: -12px; // Remove gap with table

  .ant-input {
    border: none;
    height: 100%;
    &:focus {
      box-shadow: none;
    }
  }

  .ant-input-affix-wrapper {
    border: none;
    box-shadow: none;
    margin: 0;
    height: 100%;
  }
`

export const ShowingText = styled.div`
  font-size: ${FONT.F_SM};
  color: ${COLORS.TEXT_MEDIUM};
  white-space: nowrap;
  padding: 9px 16px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 0 4px 4px 0;
  background: ${COLORS.WHITE};
  height: 48px; // Increased to match SearchSection
  display: flex;
  align-items: center;
  flex: 0.75;
  margin-bottom: -12px; // Remove gap with table
`

export const TableTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
`


export const Overlay = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 999;
`
export const SelectRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 16px;

  > div {
    flex: 1;
    min-width: 250px;
  }
`

export const ContentSection = styled.div`
  padding: 0 24px;
`

export const FormSection = styled.div`
  margin-top: 18px;
  max-width: 800px;
`
export const SectionTitle = styled.div`
  font-size: 20px;
  font-size: 20px;
  font-weight: 500;
  color: ${COLORS.BLACK};
  margin-bottom: 8px;
  padding-top: 20px;
`


export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`

export const StateCityMessage = styled.div`
  font-size: ${FONT.F_SM};
  color: ${COLORS.TEXT_MEDIUM};
  padding: 16px;
  text-align: center;
`

export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 250px !important;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .ant-tabs-nav {
    margin: 0;
    padding: 16px;
    border-right: 1px solid ${COLORS.GREY_T_90};
  }
  
  .ant-tabs-tab {
    padding: 8px 16px;
    margin: 0;
    
    &.ant-tabs-tab-active {
      background: ${COLORS.PRIMARY_BLUE_T_96};
      border-radius: 4px;
`

export const CustomStyledTable = styled(StyledTable)`
  .ant-table-thead {
    tr {
      th {
        background: ${COLORS.GREY_T_95};
        border-left: 1px solid ${COLORS.GREY_T_90};
        border-right: 1px solid ${COLORS.GREY_T_90};
      }
    }
  }

  .ant-table-tbody {
    tr {
      td {
        
        border-left: 1px solid ${COLORS.GREY_T_95};
        border-right: 1px solid ${COLORS.GREY_T_95};
      }

    }
  }
  .ant-table-expanded-row td {
    padding: ${props =>
      props?.expandedRowPadding ? props?.expandedRowPadding : '0'} !important;
  }
`

export const AssessmentName = styled.div`
  font-size: 14px;
  color: #3249D7;
  margin-top: 4px;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const EntityTypeContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${COLORS.WHITE};
  padding: 10px 18px;
  border-radius: 8px;
  border: 1px solid ${COLORS.GREY_T_90};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-right: 20px;
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

export const EntityTypeLabel = styled.span`
  margin-right: 20px;
  font-weight: 600;
  color: ${COLORS.TEXT_DARK};
  font-size: ${FONT.F_SM};
  white-space: nowrap;
`;

export const EntityTypeOptions = styled.div`
  display: flex;
  gap: 10px;
  background-color: ${COLORS.GREY_T_97};
  padding: 4px;
  border-radius: 6px;
`;

export const EntityTypeOption = styled.button`
  padding: 6px 16px;
  border-radius: 4px;
  font-size: ${FONT.F_SM};
  font-weight: ${props => props.isActive ? '600' : '500'};
  cursor: pointer;
  border: none;
  background-color: ${props => props.isActive ? COLORS.WHITE : 'transparent'};
  color: ${props => props.isActive ? COLORS.PRIMARY : COLORS.TEXT_DARK};
  transition: all 0.2s ease;
  box-shadow: ${props => props.isActive ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};
  
  &:hover {
    background-color: ${props => props.isActive ? COLORS.WHITE : COLORS.GREY_T_95};
  }
  
  &:focus {
    outline: none;
    box-shadow: ${props => props.isActive ? 
      '0 1px 3px rgba(0, 0, 0, 0.1), 0 0 0 2px ${COLORS.PRIMARY_BLUE_T_90}' : 
      '0 0 0 2px ${COLORS.PRIMARY_BLUE_T_90}'};
  }
`

export const FormSectionCard = styled.div`
  background-color: ${COLORS.WHITE};
  border-radius: 8px;
  border: 1px solid ${COLORS.GREY_T_90};
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const FormGroupTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.TEXT_DARK};
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

export const SelectField = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: ${COLORS.TEXT_DARK};
  }
`;

// Refined SelectRow with better spacing and alignment
export const EnhancedSelectRow = styled(SelectRow)`
  align-items: flex-start;
  background-color: ${COLORS.WHITE};
  padding: 4px 0;
  
  > div {
    flex: 1;
  }
`;